<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import teamfoto from "$lib/images/Team.jpg?enhanced";

  let { sectionLabel = "", tagline = "", description = "", imgDescription="", imagePlaceholder = "" } = $props();
</script>

<section>
  <div class="container">
    <div class="about-hero">
      <div class="fade-up" use:observe>
        {#if sectionLabel}
          <span class="section-label">{sectionLabel}</span>
        {/if}
        <h1>{tagline}</h1>
        <p class="copy">{description}</p>
      </div>
      {#if imagePlaceholder}
        <div class="fade-up" use:observe style="transition-delay:.15s; text-align: center">
          <div class="card-thumb" style="aspect-ratio:4/3;background:var(--border);border-radius:var(--radius-md);display:flex;align-items:center;justify-content:center;color:var(--muted);font-size:0.9rem">
            <enhanced:img src={teamfoto} alt="Practical Team" />
          </div>
          <small>{imgDescription}</small>
        </div>
      {/if}
    </div>
  </div>
</section>
